var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import ConfirmationModal from '../ConfirmationModal.vue';
import localForage from 'localforage';
import helper from '../../../ts/helper';
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = '';
        _this.password = '';
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Login.prototype.mounted = function () {
    };
    //modal
    Login.prototype.openModal = function () {
        this.$data.modal = true;
    };
    Login.prototype.closeModal = function () {
        this.$data.modal = false;
        this.$data.info_modal = false;
    };
    Login.prototype.signinSend = function () {
        //ログイン処理
        this.$data.signin_modal = false;
    };
    Login.prototype.setData = function (address, privateKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.$data.wallet.setData(address, privateKey);
                return [2 /*return*/];
            });
        });
    };
    Login.prototype.login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var request, url, send, savedata, token, client, uid, Headers;
            var _this = this;
            return __generator(this, function (_a) {
                request = new XMLHttpRequest();
                url = this.$data.helper.path + "auth/sign_in";
                console.log(url);
                send = new FormData();
                send.append("email", this.email);
                send.append("password", this.password);
                savedata = [];
                request.open('POST', url);
                request.send(send);
                request.onreadystatechange = function () {
                    if (request.readyState != 4) {
                        // リクエスト中
                        console.log('リクエスト中');
                    }
                    else if (request.status != 200) {
                        // 失敗
                        console.log('失敗');
                        var result = request.responseText;
                        alert(result);
                    }
                    else {
                        // 取得成功
                        console.log('取得成功');
                        var result = request.responseText;
                        savedata = JSON.parse(result);
                        if (savedata.data.registered_status == -1) {
                            alert("ログイン情報が正しくありません。");
                        }
                        else {
                            alert("ログインしました。");
                            token = request.getResponseHeader('access-token');
                            uid = request.getResponseHeader('uid');
                            client = request.getResponseHeader('client');
                            console.log(savedata.data.registered_status);
                            console.log(token);
                            console.log(uid);
                            console.log(client);
                            console.log(savedata);
                        }
                    }
                };
                setTimeout(function () {
                    if (savedata.data.registered_status != -1) {
                        localForage.clear();
                        console.log(savedata);
                        Headers = {
                            'access-token': token,
                            'uid': uid,
                            'client': client
                        };
                        _this.getData(Headers, savedata.data.address);
                        console.log(savedata.data.address);
                        if (savedata.data.address) {
                            _this.$data.helper.saveData(savedata.data);
                            _this.$data.helper.save('Headers', Headers);
                        }
                    }
                }, 1500);
                this.closeModal();
                return [2 /*return*/];
            });
        });
    };
    Login.prototype.getData = function (Headers, address) {
        var _this = this;
        var access_token = Headers["access-token"];
        var uid = Headers["uid"];
        var client = Headers["client"];
        var request = new XMLHttpRequest();
        var result = "";
        var url = this.$data.helper.path + "auth_users/initial_data/" + address;
        console.log(url);
        request.open('GET', url);
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("access-token", access_token);
        request.setRequestHeader("uid", uid);
        request.setRequestHeader("client", client);
        request.onreadystatechange = function () {
            if (request.readyState != 4) {
                // リクエスト中
                console.log('リクエスト中');
            }
            else if (request.status != 200) {
                // 失敗
                console.log('失敗');
            }
            else {
                // 取得成功
                console.log('取得成功');
                result = request.response;
                console.log(request);
            }
        };
        request.send(null);
        setTimeout(function () {
            if (result != '') {
                _this.$data.helper.saveInitialData(result);
            }
        }, 1000);
    };
    Login = __decorate([
        Component({
            data: function () { return ({
                modal: false,
                helper: new helper(),
            }); },
            components: { ConfirmationModal: ConfirmationModal },
            props: ['address', 'private_key', 'public_key', 'version']
        })
    ], Login);
    return Login;
}(Vue));
export default Login;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/details/Login.vue
// module id = 156
// module chunks = 1